import { ReactNode } from "react";
import Button from "components/Button/Button";
import styles from "./PromotionModalActions.module.css";

interface Props {
  cancelLabel: ReactNode;
  confirmLabel: ReactNode;
  loading?: boolean;
  onCancel(): void;
  onConfirm(): void;
}

const PromotionModalActions = ({
  cancelLabel,
  confirmLabel,
  loading = false,
  onCancel,
  onConfirm,
}: Props) => (
  <div className={styles.actions}>
    <Button type="secondary" onClick={onCancel} className={styles.button}>
      {cancelLabel}
    </Button>
    <Button
      fluid
      type="primary"
      onClick={onConfirm}
      className={styles.button}
      loading={loading}
    >
      {confirmLabel}
    </Button>
  </div>
);

export default PromotionModalActions;
